import Cookies from 'js-cookie';
import WashdayClientSingleton from './WashdayClientSingleton';
import { acceptSessionToken, type SessionTokenDispatch } from './sessionToken';

const checks = new Map<string, Promise<boolean>>();

export function verifyCurrentSession(dispatch: SessionTokenDispatch): Promise<boolean> {
  const token = Cookies.get('token');
  if (!token) return Promise.resolve(false);
  const pending = checks.get(token);
  if (pending) return pending;
  const check = WashdayClientSingleton.getInstance()
    .axiosInstance.get('api/auth', {
      timeout: 10_000,
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => {
      if (Cookies.get('token') !== token) return false;
      acceptSessionToken(response.data?.data?.token, token, dispatch);
      return true;
    })
    .catch(() => false)
    .finally(() => {
      checks.delete(token);
    });
  checks.set(token, check);
  return check;
}
